import React from 'react';
import './index.scss';

function Bottomfooter(props) {
    return null
}

export default Bottomfooter;
